module.exports = function getResource(label, vars = []) {
    let resources = {
        //BasketList
        itemsInBasketMessage: `Articles dans le panier (${vars[0]})`,
        emptyBasketMessage: 'Votre panier est actuellement vide.',
        shopNewArrivals: 'Découvrir les nouveautés',
        pleaseSignIn: `Veuillez ${vars[0]} si vous essayez de récupérer un panier créé précédemment.`,
        signInText: 'ouvrir une session',
        emptyRopisBasketTitle: 'Vider le panier',
        emptyRopisBasket: 'Votre panier Réservation et cueillette est vide. Vous serez dirigé vers votre panier de commandes en ligne',
        ok: 'OK',

        //BasketListItem
        shippingRestrictionPopoverText: 'En raison des réglementations d’expédition, cet article et le reste de votre commande doivent être expédiés par voie terrestre (livraison en 2 à 8 jours au total). Cela inclut les livraisons FLASH et les livraisons express.',
        shippingRestrictions: 'Restrictions d’expédition',
        rewardCardText: 'La récompense Rouge est valable pour *une transaction future uniquement*; elle *expire dans 90 jours* et sera envoyée par courriel dans les *24 heures*.',
        remove: 'Supprimer',
        moveToLoves: 'Déplacer vers les favoris',
        loved: 'Coup de coeur',
        outOfStock: 'rupture de stock',
        outOfStockAtStore: 'Rupture de stock dans certains magasins',
        soldOut: 'épuisé'
    };

    return resources[label];
};
